import { useAuth } from "../hooks/useAuth";
import { Redirect } from "./Redirect";
import type { User } from "../hooks/useAuth";

export function AuthRedirect({
  children,
  condition,
}: {
  children: React.ReactNode;
  condition: (user: User | null) => string | undefined;
}) {
  const { user } = useAuth();
  const redirectTo = condition(user);
  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }
  return <>{children}</>;
}
